import { InjectionToken } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import { FormGroupRegexValidators } from '../utils/form-group-utils';
import { resolveByCountry } from './country-resolver';

export const POSTAL_CODE_VALIDATOR_TOKEN = new InjectionToken<ValidatorFn[]>('PostalCodeValidatorToken');

export const US_POSTAL_CODE_VALIDATORS: ValidatorFn[] = [Validators.required, Validators.pattern(FormGroupRegexValidators.zipUS)];

export const AU_POSTAL_CODE_VALIDATORS: ValidatorFn[] = [Validators.required, Validators.pattern(FormGroupRegexValidators.zipAU)];

/** Resolves the postal-code validators for the given country code. */
export function postalCodeValidatorsFor(country: string | undefined | null, productDefault: ValidatorFn[]): ValidatorFn[] {
    return resolveByCountry(country, US_POSTAL_CODE_VALIDATORS, AU_POSTAL_CODE_VALIDATORS, productDefault);
}
